import dayjs from 'dayjs';

interface FieldRenderOptions {
  data: any;
}

export const useFieldRenderer = ({ data }: FieldRenderOptions) => {
  const renderField = (field: any) => {
    // Handle gender field with special mapping
    if (field.name === 'patient_gender_code') {
      return data.gender_string;
    }

    // Handle previous product name field
    if (field.name === 'previous_product_name') {
      return data[field.name] === '1' ? 'YES' : 'NO';
    }

    if (field.name === 'has_not_dispensed') {
      return data[field.name] ? 'YES' : 'NO';
    }

    // Handle boolean fields
    if (typeof data[field.name] === 'boolean') {
      return data[field.name] ? 'YES' : 'NO';
    }

    // Handle numeric fields
    if (typeof data[field.name] === 'number') {
      return data[field.name];
    }

    // Handle date fields
    if (data[field.name] && typeof data[field.name] === 'string') {
      const dateRegex =
        /^\d{4}(-|\/)\d{2}(-|\/)\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{3})?([+-]\d{2}:\d{2}|Z)?)?$/;
      const value = data[field.name];

      if ((dateRegex.test(value) || value.includes('T')) && dayjs(value).isValid()) {
        return dayjs(value).format('MM-DD-YYYY');
      }
    }

    return data[field.name];
  };

  return { renderField };
};
